import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { isNotEmpty } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';

import PromoColsWrapper from '../../components/front/PromoColsWrapper';

import SaveButton from '../builder/SaveButton.js';
import PunchCardCanvas from '../games/PunchCardCanvas.js';

import { WinnerPrizeIndex } from '../prizes/WinnerContent.js';

const PunchCardClient = (props) => {
	useCSS('comp/punch_cards.css');

	const stage = props.stage.Stage;
	let participations = {};
	if(props.participations != undefined) {
		participations = (props.participations[stage.id] != undefined) ? props.participations[stage.id] : props.participations;
	}

	const only_display = props?.only_display ?? false;
	const is_builder = props?.is_builder ?? false;
	const only_contents = (is_builder) ? (props?.only_contents ?? false) : false;
	const is_completed = props?.is_completed ?? false;
	const force_num_stamps = props?.force_num_stamps ?? false;

	const num_punches = parseInt(stage?.punch_num_punches ?? 5);
	const current_participations = participations?.num_participations ?? 0;

	let cstamps = parseInt(current_participations % num_punches);
	if(is_completed || only_display && current_participations > 0 && cstamps == 0) {
		// To display the full card when only viewing it but not participating on it:
		cstamps = num_punches;
	}
	if(force_num_stamps !== false) {
		// To display a number of codes already preprocessed (in use in Audience):
		cstamps = force_num_stamps;
	}

	const current_stamps = parseInt(cstamps);
	
	const [ display_button, setDisplayButton ] = useState(false);
	const [ force_display_button, setForceDisplayButton ] = useState(false);
	const [ showingPrizes , setShowingPrizes] = useState(false);

	//const coming_stamps = useRef(7);
	const coming_stamps = useRef((!only_display) ? (props.coming_stamps ?? 5) : 0);
	const punch_canvas = useRef();
	const responses = useRef(false);
	const prizes = useRef([]);

	const is_test = false;

	const canvas_images =() => {
		const images = [];

		if(isNotEmpty(stage, 'punch_image_off')) {
			images.push({
				id:'image_off',
				name:'image_off',
				url:stage.full_punch_image_off,
				fit:'contain',
			});
		}

		if(isNotEmpty(stage, 'punch_image_on')) {
			images.push({
				id:'image_on',
				name:'image_on',
				url:stage.full_punch_image_on,
				fit:'contain',
			});
		}

		(stage?.punch_images != undefined && stage?.punch_images != "" ? stage.punch_images :[]).map((image) => {
			if(isNotEmpty(image, 'image_on')) {
				images.push({
					id:`image_on_${image.position}`,
					name:image.image_on,
					url:image.full_image_on,
					image:image.full_image_on,
					fit:'contain',
				});
			}

			if(isNotEmpty(image, 'image_off')) {
				images.push({
					id:`image_off_${image.position}`,
					name:image.image_off,
					url:image.full_image_off,
					image:image.full_image_off,
					fit:'contain',
				});
			}
		});

		return images;
	}

	const punch_images_key = ((isNotEmpty(stage, 'punch_images')) ? stage.punch_images : []).reduce((a, c) => {
		return a + c?.image_on+c.position + c?.image_off+c.position;
	}, '');

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[punch_images_key, stage.punch_image_off, stage.punch_image_on],
	});

	const participate = (e, cb) => {
		if(props.participate == undefined) return;

		props.participate((res) => {
			punch_canvas.current.addStamp(res);

			responses.current = res;

			if(res.prize == true) {
				$.get(res.url.replace('success','users/prizes'), (response) => {
					response.map((p) => {
						prizes.current.push(p);
					});
				}, 'JSON');
			}

			if(coming_stamps.current > 1 && res.status == 1) {
				coming_stamps.current--;
				participate(e, cb);
			}
		});
	};
	
	useEffect(() => {
		if(!is_builder) return;

		setForceDisplayButton(props.display_button);
	}, [ props.display_button ]);

	useEffect(() => {
		if(is_builder) return;
		if (state.state != 'LOADED')return;
		participate();
	}, [state.state]);
	
	const punchcard = [];
	for(let i = 0; i < num_punches; i++) {
		punchcard.push(i < current_stamps);
	}

	const btn_text = (isNotEmpty(stage, 'direct_btn_text')) ? stage.direct_btn_text : "Continue";

	const canvas_w = 360;
	const canvas_h = 580;

	const container_styles = {
		width:`${canvas_w}px`,
		height:`${canvas_h}px`,
	};

	const calcContainerSize = (cb) => {
		const optimized_height_for_widget = (window.parent_location_w != undefined && window.parent_location_h != undefined) ? (Math.min(window.parent_location_w, window.parent_location_h) + 70) : 700;
		adaptHeightOnWidget(optimized_height_for_widget);

		if(cb != undefined) {
			const container = document.querySelector('.punch_card');
			cb({
				w:Math.floor(container.clientWidth),
				h:Math.floor(container.clientHeight),
			});
		}
	};

	const bg_styles = {};
	if(isNotEmpty(stage, 'full_bg_image')) {
		bg_styles.backgroundImage = `url(${stage.full_bg_image})`;
	} else {
		bg_styles.backgroundColor = stage?.bg_color ?? 'white';
	}

	const canvas_styles = { position:'relative' };

	if(state.state != 'LOADED') return <div>Loading...</div>

	if(only_contents) {
		return (
			<div class="punch_card only_contents gui_flexbox gui_flex_col gui_flex_align_center" style={container_styles}>
				<div class="punch_bg" style={bg_styles} />

				<div class="punch_canvas" style={canvas_styles}>
					<PunchCardCanvas
						ref={punch_canvas}
						stage={stage}
						promotion={props.promotion}
						indexed_images={state.images}
						coming_stamps={coming_stamps.current}
						current_stamps={current_stamps}
						areaChanged={props?.areaChanged}
						is_builder={is_builder}
						force_display_stamps={props.force_display_stamps}
						only_display={only_display}
						adaptToContainer={calcContainerSize}
					/>
				</div>

				{(isNotEmpty(props, 'extra_contents')) && (
					<div class="footer_contents">{props.extra_contents}</div>
				)}
			</div>
		)
	}

	return (
		<PromoColsWrapper
			extra_classes="gui_direct_participation"
		>
			<article class="template_module info_flexwrap gui_main_actions">
				<div class="template_submodule mod_align_center call_to_action_flex in_bottom">
					<div class="punch_card" style={container_styles}>
						<div class="punch_bg" style={bg_styles} />

						<div class="punch_canvas" style={canvas_styles}>
							<PunchCardCanvas
								ref={punch_canvas}
								stage={stage}
								promotion={props.promotion}
								indexed_images={state.images}
								coming_stamps={coming_stamps.current}
								current_stamps={current_stamps}
								areaChanged={props?.areaChanged}
								is_builder={is_builder}
								force_display_stamps={props.force_display_stamps}
								is_editing={props?.is_editing ?? false}
								is_playable={false}
								only_display={only_display}
								adaptToContainer={calcContainerSize}
								showContinueButton={() => {
									if(is_builder) return;
									setDisplayButton(true);
									setShowingPrizes(true);
								}}
							/>
						</div>

						{((!is_builder && display_button) || force_display_button) && (
							<div class="cta is_overlapped flex_button gui_big_button">
								<SaveButton
									_fullclass=""
									_href={responses.current?.url ?? null}
								>{btn_text}</SaveButton>
							</div>
						)}
					</div>
				</div>

				{(prizes.current.length > 0 && showingPrizes) && (
					<WinnerPrizeIndex
						prizes={prizes.current}
						layout_props={props.promotion.layout_props}
						backButton={() => setShowingPrizes(false)}
						intl={props.intl}
					/>
				)}
			</article>
		</PromoColsWrapper>
	);
};

export default injectIntl(PunchCardClient);